import { createSelector } from 'reselect'
import { get, geti18n } from '../../utils';

export const activeZipCode = state => get(state, 'dma.zipCode')
export const activeModelLineCode = state => get(state, 'navigation.modelLineCode');
export const activeNCode = state => get(state, 'navigation.nCode');
export const activeCreditRating = state => get(state, 'userAmounts.creditRating');
export const showAllPaymentOptions = state => get(state, 'userAmounts.showAllPaymentOptions');
export const allPaymentOptions = state => get(state, 'paymentOptions.options');

export const getPaymentOptions = createSelector(
    allPaymentOptions,
    activeModelLineCode,
    activeNCode,
    activeZipCode,
    activeCreditRating,
    (paymentOptions, modelLineCode, nCode, zipCode, creditRating) =>
        get(paymentOptions, [modelLineCode, nCode, zipCode, creditRating])
);

export const getVisiblePaymentOptions = createSelector(
    getPaymentOptions,
    (paymentOptions) => {
      const sanatizePaymentOptions = (paymentType, options) => {
        const filteredOptions = options.filter(Boolean).map((option, idx) => {
          const key = option.promoId ? `-${option.promoId}` : '';
          const isOpen = idx < 1;
          const optionType = option.isOffer === true ? 'OFFER' : 'INCENTIVE';
          return {
            ...option,
            isOpen,
            reactKey: `${paymentType}-${optionType}${key}`,
            paymentType
          }
        });
        return filteredOptions;
      }
      const lease = get(paymentOptions, 'lease', []);
      const finance = get(paymentOptions, 'finance', []);
      return {
        EmptyOptions: false,
        purchase: sanatizePaymentOptions('FINANCE', finance),
        lease: sanatizePaymentOptions('LEASE', lease),
      }
    }
)

export const isPaymentOptionsLoading = (state) => {
  const optionsLoading = state.bestOffers.loading;
  return !!(optionsLoading === true);
}

export const createLocateARetailerURL = (state) => {
  const vendor = get(state, 'environment.VENDOR');
  const locateText = geti18n('linkPaths.locateARetailer');
  const zipCode = get(state, 'dma.zipCode');
  return vendor === 'helios' ? locateText : `${locateText}${zipCode}`;
};

export const createRequestAQuoteURL = (state) => {
  const vendor = get(state, 'environment.VENDOR');
  const channel = get(state, 'environment.BRAND_CHANNEL');
  const quoteText = geti18n('linkPaths.requestAQuote');
  const lang = get(state, 'environment.LANG');
  // const zipCodeAmp = geti18n('linkPaths.zipCodeAmp');
  const modelLines = get(state, 'modellines.models');
  const modelLineCode = get(state, 'navigation.modelLineCode');
  const model = modelLines.find(m => m.modelLineCode === modelLineCode);
  const zipCode = get(state, 'dma.zipCode');
  if (vendor === 'nna') {
    if (channel === 'in') {
      return (model) ? `${quoteText}?modelLineCode=${modelLineCode}&zipCode=${zipCode}` : undefined;
    }
    return (model) ? `${quoteText}?modelLineCode=${modelLineCode}&lang=${lang}&zipCode=${zipCode}?tool=payment-estimator.inventory.link` : undefined;
  } else if (vendor === 'helios') {
    return quoteText;
  }
  return '';
};

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/redux/selectors/paymentOptions.js
 **/